import React from 'react';
import Immutable from 'immutable';
import TabPane from '../../containers/tabpane';

const EMPTY_LIST = Immutable.List([]);

export default function TabPaneDefinition() {
	if (!(this instanceof TabPaneDefinition)) {
		return new TabPaneDefinition();
	}

	let selectedTabIdPath;
	let tabDefinitions;
	let contentDefinitionMap;

	let header;
	let vertical;
	let tabStripWidth;
	let contentClassName;
	let margin;
	let onTabSelected;

	const updateContentDefinitionMap = function() {
		contentDefinitionMap = {};
		tabDefinitions.forEach(def => {
			contentDefinitionMap[def.getId()] = def; //.getContent();
		});
	};

	this.setOnTabSelected = function(value) {
		if (typeof value === 'function') {
			onTabSelected = value;
		} else {
			onTabSelected = null;
		}
		return this;
	};

	this.setMargin = function(value) {
		margin = value;
		return this;
	};

	this.setContentClassName = function(value) {
		contentClassName = value;
		return this;
	};

	this.setHeader = function(value) {
		header = value;
		return this;
	};

	this.setVertical = function(value) {
		vertical = value;
		return this;
	};

	this.setTabStripWidth = function(value) {
		tabStripWidth = value;
		return this;
	};

	this.getItems = function() {
		return tabDefinitions;
	}

	this.setTabs = function(value) {
		tabDefinitions = Immutable.List(value);
		tabDefinitions.forEach(item => {
			item._parentDefinition = this;
		});
		updateContentDefinitionMap();
		return this;
	};

	this.setSelectedTabIdPath = function(value) {
		selectedTabIdPath = value;
		return this;
	};

	this.validateAll = function(ctx, errors) {
		tabDefinitions.forEach(def => {
			if (def.isVisible(ctx)) {
				def.getContent().validateAll(ctx, errors);
			}
		});
	};

	this.render = function(ctx, key = 0) {
		let selectedTabId = ctx.getProperty(selectedTabIdPath);
		let selectedTabIsVisible = false;
		let tabs = [];
		tabDefinitions.forEach(def => {
			if (!def.isVisible(ctx)) {
				return;
			}
			if (!selectedTabIsVisible && selectedTabId === def.getId()) {
				selectedTabIsVisible = true;
			}
			tabs.push(def.getTab());
		})
		if (tabs.length === 0) {
			return null;
		}
		tabs = Immutable.List(tabs);
		if (!selectedTabIsVisible) {
			selectedTabId = tabs.getIn([0, 'id']);
		}
		const selectedTab = contentDefinitionMap[selectedTabId];
		let contentDefinition;
		let tabContentClass;
		if (selectedTab) {
			contentDefinition = selectedTab.getContent();
			tabContentClass = ((selectedTab.getContentClassName() || '') + ' ' + (contentClassName || '')).trim();
		} else {
			tabContentClass = contentClassName;
		}
		return (
			<TabPane
				key={key}
				header={header}
				tabs={tabs}
				vertical={vertical}
				selectedTabId={selectedTabId}
				onTabSelected={selectedTabId => {
					window.setTimeout(() => {
						ctx.setProperty(selectedTabIdPath, selectedTabId);
					}, 0);
					if (onTabSelected) {
						onTabSelected(ctx, selectedTabId);
					}
				}}
				tabStripWidth={tabStripWidth}
				contentClassName={tabContentClass}
				margin={margin}
			>
				{
					contentDefinition ? contentDefinition.render(ctx, selectedTabId) : null
				}
			</TabPane>
		);
	};
}
/*
					<TabPane
						header="Sekce"
						tabs={tabs}
						vertical={false}
						selectedTabId={this.state.selectedTabId}
						onTabSelected={selectedTabId => {
							this.setState({selectedTabId});
						}}
						tabStripWidth="260px"
					>
						<Centerer>
						{
							definition.render(ctx)
						}
						</Centerer>
					</TabPane>
*/